import api, { ApiResponse } from './api';

export interface Proxy {
  id: number;
  name: string;
  proxy_host: string;
  proxy_port: number;
  proxy_username: string | null;
  proxy_password: string | null;
  proxy_type: 'http' | 'https' | 'socks5';
  is_active: number;
  is_default: number;
  last_check_at: string | null;
  last_check_status: string | null;
  created_at: string;
}

export interface CreateProxyRequest {
  name?: string;
  proxy_host: string;
  proxy_port: number;
  proxy_username?: string;
  proxy_password?: string;
  proxy_type?: 'http' | 'https' | 'socks5';
  is_default?: boolean;
}

export interface UpdateProxyRequest {
  name?: string;
  proxy_host?: string;
  proxy_port?: number;
  proxy_username?: string;
  proxy_password?: string;
  proxy_type?: 'http' | 'https' | 'socks5';
  is_active?: boolean;
}

export interface TestProxyResponse {
  working: boolean;
  latency?: number;
  ip?: string;
  status: string;
  error?: string;
}

export const proxyService = {
  async list(): Promise<Proxy[]> {
    const response = await api.get<ApiResponse<Proxy[]>>('/proxies');
    return response.data.data;
  },

  async get(id: number): Promise<Proxy> {
    const response = await api.get<ApiResponse<Proxy>>(`/proxies/${id}`);
    return response.data.data;
  },

  async create(data: CreateProxyRequest): Promise<Proxy> {
    const response = await api.post<ApiResponse<Proxy>>('/proxies', data);
    return response.data.data;
  },

  async update(id: number, data: UpdateProxyRequest): Promise<Proxy> {
    const response = await api.put<ApiResponse<Proxy>>(`/proxies/${id}`, data);
    return response.data.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/proxies/${id}`);
  },

  async test(id: number): Promise<TestProxyResponse> {
    const response = await api.post<ApiResponse<TestProxyResponse>>(`/proxies/${id}/test`);
    return response.data.data;
  },

  async setDefault(id: number): Promise<void> {
    await api.post(`/proxies/${id}/set-default`);
  },
};
